import React from "react";
import { View, Text, Pressable, StyleSheet } from "react-native";
import { CheckMark } from "../../svgs/common";
import CustomText from "../../common/general/CustomText/CustomText";
import { formatDate } from "../../../utils/date";

function ItemCard({ title, dueDate, isComplete = false, isHover, label, onPress, className }) {
  return (
    <View
      style={[
        styles.card,
        isHover && {
          backgroundColor: "#EAEFFE",
        },
      ]}>
      <Pressable
        style={styles.infoContainer}
        onPress={onPress}
        role="button"
        aria-label={`Open Item, ${title}`}
        accessibilityHint="Double tap to open the item">
        <View style={styles.rightColContainer}>
          <View style={styles.tagContainer}>
            <View style={styles.tag}>
              <Text style={styles.tagText}>{label}</Text>
            </View>
            {className && (
              <View style={[styles.tag, { marginLeft: 5 }]}>
                <Text style={styles.tagText}>{className}</Text>
              </View>
            )}
          </View>
          <CustomText useTranslationText={false} text={title} size="m" />
        </View>

        {isComplete ? (
          <View
            style={{
              borderRadius: 100,
              backgroundColor: "#22C55E",
              marginRight: 8,
              padding: 4,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
            }}>
            <View style={{ paddingHorizontal: 4 }}>
              <CustomText useTranslationText={false} text="Complete" styleType="light" size="s" />
            </View>
            <CheckMark width={14} height={16} fill="#FFFFFF" />
          </View>
        ) : (
          <CustomText useTranslationText={false} text={formatDate(dueDate)} size="s" />
        )}
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flex: 1,
    flexDirection: "column",
    padding: 20,
    backgroundColor: "#fff",
    borderTopColor: "#D9D9D9",
    borderTopWidth: 1,
    borderBottomColor: "#D9D9D9",
    borderBottomWidth: 1,
  },
  rightColContainer: {
    flexDirection: "column",
  },
  infoContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tagContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignContent: "center",
    marginVertical: 4,
  },
  tag: {
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
    backgroundColor: "#E6EBFF",
    borderRadius: 100,
    alignContent: "center",
  },
  tagText: {
    color: "#022CC4",
    fontSize: 10,
    fontWeight: "700",
    wordWrap: "break-word",
  },
});

export default ItemCard;
